import { useMemo } from 'react';

import { arc } from 'd3-shape';

interface ArcDatum {
  startAngle: number;
  endAngle: number;
}

interface UseArcPathOptions {
  innerRadius: number;
  outerRadius: number;
  cornerRadius?: number;
}

const DEFAULT_CORNER_RADIUS = 0;

const useArcPath = ({ innerRadius, outerRadius, cornerRadius = DEFAULT_CORNER_RADIUS }: UseArcPathOptions) =>
  useMemo(
    () => arc<ArcDatum>().innerRadius(innerRadius).outerRadius(outerRadius).cornerRadius(cornerRadius),
    [innerRadius, outerRadius, cornerRadius]
  );

export { useArcPath };
